import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { Input } from '@art-of-hospitality-solutions-llc/ui-kit/components/input';
import { useFishDetails } from '../FishDetailsContext';

/**
 * Amount entry for a wallet adjustment. The dry run populates the confirm
 * dialog in FishDetailsOverlays, which performs the actual adjustment.
 */
export default function WalletAdjustDialogBody() {
  const {
    adjustAmount,
    adjustDisabled,
    adjustSuccess,
    dryError,
    dryRunAdjustWallet,
    handleAdjustUpdate,
    walletBalance,
  } = useFishDetails();

  return (
    <div className="flex flex-col gap-4">
      <div>
        Current Wallet Balance:{' '}
        <span className="font-semibold">
          {walletBalance !== null
            ? `$${Number(walletBalance)?.toFixed(2)}`
            : 'N/A'}
        </span>
      </div>

      {adjustSuccess && <span className="text-green-600">{adjustSuccess}</span>}

      {dryError && <span className="text-red-600">{dryError}</span>}

      <div className="flex w-full items-end gap-2">
        <div className="flex-1">
          <label className="block text-sm font-medium">
            Adjust Wallet by Amount
          </label>
          <Input
            placeholder="-200"
            value={adjustAmount}
            onChange={handleAdjustUpdate}
          />
        </div>
        <Button
          disabled={adjustDisabled}
          type="submit"
          className={adjustDisabled ? 'cursor-not-allowed opacity-50' : ''}
          onClick={() => dryRunAdjustWallet()}
        >
          Adjust
        </Button>
      </div>
    </div>
  );
}
